"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  micro: 4,
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32,
  xl: 40,
  mdx2: 48,
  xxl: 56,
  xxxl: 64,
  yuge: 80,
  contentMaxWidth: 1280,
  globalNavHeight: 80
};
exports["default"] = _default;